// Tender conversion stores the announcement in the legacy url field.
// Use its generated origin marker so manually maintained company websites keep their meaning.
export function customerLink(data = {}) {
  const isSource = String(data.remark || '').startsWith('由污水处理招投标信息池自动创建，来源：')
  const value = String(data.url || data.website || '').trim()
  return {
    label: isSource ? '来源链接' : '公司网址',
    text: isSource ? '查看来源' : '查看官网',
    value,
    href: /^https?:\/\/[^\s<>"']+$/i.test(value) ? value : ''
  }
}
